export const createImgSources = (img, source = null) =>
  img
    ? {
        "regular@1x": img,
        "regular@2x": img,
        "regular@3x": img,
      }
    : source;
